import { Navigate } from "react-router-dom";
import Spinner from "../spinner/Spinner";
import useAuth from "../../helper/hooks/useAuth";

const PrivateRoute = ({ children }) => {
  const { user, userLoading } = useAuth();
  if (userLoading) return <Spinner />;
  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
